export default {
  banner: {
    title: "Financial Services",
    subtitle: `Internally enhance security and risk control. Externally enhance the financial service experience and realize digital transformation.`,
  },
  marquee: {
    item1: {
      title1: `A "Fortune 500" bank`,
      desc1:
        "It was the first pilot bank in the country to promote banking reform from outside the system. ",
      title2: "Risk control system",
      desc2: `Authing worked with us to improve the risk control capabilities of our original identity system, giving us a head start in eliminating risk. In addition, we were surprised by Authing's API/SDK, which is very fast to embed and integrate.`,
    },
    item2: {
      title1: "A famous one-stop investment platform",
      desc1: `The country's first free Hong Kong and U.S. A-share LV2 quotes, data analysis of the Internet brokerage platform.`,
      title2: "Flexible apps integration",
      desc2:
        "Authing's cloud-neutral and developer-friendly features make it easier for us to access various local applications and overseas software, and ensure the security and control of data and information.",
    },
    item3: {
      title1: "A leading insurance provider",
      desc1:
        "The company was ranked No. 1 in the NPS published by Bain & Company.",
      title2: "Efficiently authentication",
      desc2:
        "Authing's product backend is very user-friendly, quick to get started, and very responsive, helping us to build a complex identity system with very little effort.",
    },
    item4: {
      title1: "A TOP fund service provider",
      desc1:
        "An innovative financial technology company that makes deep use of Internet technology.",
      title2: "Cloud-based elements",
      desc2:
        "Authing's cloud-based native elastic scaling capabilities and low code expansion allow us to achieve more secure and granular identity management and provide users with a better service experience.",
    },
  },
  question: {
    title: "The digital transformation of finance is imminent",
    cardOne: {
      title: "Multi-system data fragmentation",

      descli1:
        "Multiple authentication is required when using different business systems. This leads to difficult account unification and inefficient operations.",
      descli2:
        "Employees are frequently transferred within the enterprise, and there are a large number of non-staff personnel outside the enterprise. This leads to poor O&M efficiency and the risk of missing privileges.",
    },
    cardTwo: {
      title: "Confusing permission management",
      descli1:
        "Multiple parallel sets of each business system lead to scattered authority management. And the lack of a unified policy leads to low security and efficiency.",
      descli2:
        "The business logic of permission management is complex, especially in the financial industry, and self-research systems require significant development costs and low ROI.",
    },
    cardThree: {
      title: "Clear trend towards localization",
      descli1:
        "According to the analysis, the proportion of basic hardware and software in IT outsourcing will be further increased to 15-25%; financial IT is expected to achieve full localization in 2025.",
      descli2:
        "Under the trend of independent and controllable information innovation, it is necessary to meet the new trend of replacing AD with localized systems.",
    },
    cardFour: {
      title: "Increasingly strict regulation",
      descli1: `Enterprises should improve user authentication, access control, data encryption, logging, illegal intrusion detection and other protective measures. -- China Securities Regulatory Commission Order No. 152`,
      descli2: `Enterprises should establish a sound information technology infrastructure and security assurance system; adopt technical means such as border protection intrusion detection and data protection. -- Internet Insurance Business Supervision Measures`,
      descli3:
        "A sound risk governance structure, risk management policies and procedures, internal control and audit system shall be established to adapt to the business characteristics of Internet lending. -- Interim Measures for the Administration of Internet Loans by Commercial Banks",
    },
  },
  chart: {
    title: "Accelerating digitization based on identity",
    img: "https://files.authing.co/authing-website/finance-frame-en.png",
  },
  advantage: {
    item1: {
      title: "Unified identity authentication for efficiencient operation",
      desc: `Pre-integrated 2000+ applications and self-developed applications can help enterprises efficiently establish SSO and manage multiple system accounts in one place effectively, avoiding the security risks brought by manual IT operation.`,
      alt: "",
    },
    item2: {
      title: "Fine-grained authorization management for information security",
      desc:
        "Authing provides RBAC, ABAC, NGAC and other permission management models to help enterprises establish appropriate permission control policies for different scenarios. Developers only need to access the API/SDK to implement permission management. They can also dynamically adjust employee access rights through Pipeline and Webhook extension capabilities.",
      alt: "",
    },
    item3: {
      title: `Microsoft AD Optimization Solution for "localization" needs`,
      desc: `The policy accelerates the trend of "localization". Through the "Enhanced Microsoft AD Identity Solution", Authing can effectively complement the inability to connect to cloud applications; or help enterprises to make painless migration and establish independent and controlled infrastructure software systems.`,
      alt: "",
    },
    item4: {
      title:
        "Intelligent financial risk control center for security compliance",
      desc: `With a "zero trust" architecture, it can achieve the effect of "prevent risks beforehand", "real-time monitoring during the event", and "retrospective analysis and optimization of policies afterwards". Through global and unified audit log management, it can also meet the supervision requirements.`,
      alt: "",
    },
  },
  productivity: {
    title: "选择高安全、高性能、高生产力的身份产品",
    item1: {
      title: "高安全",
      desc1:
        "数据存储使用 AES-256 算法加密；通过 SSL/TLS 协议加密传输；使用 KMS 管理密钥，密钥定期轮换。",
      desc2: "7x24 小时的安全应急响应；两地三中心备份，保证灾难时快速恢复。",
      desc3: "ISO、等保三级、数据保护条例等多项认证。",
    },
    item2: {
      title: "高性能",
      desc1:
        " 云原生：采用 Kubernetes 容器化技术，支持分钟级别弹性扩容，最大可支持亿级别用户认证访问场景。",
      desc2: "云中立：最大程度兼容用户的云环境，不被原有的云厂商捆绑。",
    },
    item3: {
      title: "高生产力",
      desc1: " 开发者友好：提供丰富登录、认证、授权 API/SDK，降低研发成本。",
      desc2: "快速集成 2000+ 主流应用，简单、高效的建立身份中台。",
    },
  },
};
